export function statusLabel(status: string): string {
  if (status === "approved") return "Approved";
  if (status === "submitted") return "Submitted";
  if (status === "rejected") return "Rejected";
  if (status === "cancelled") return "Cancelled";
  if (status === "draft") return "Draft";
  return status;
}

export function statusBadge(status: string): string {
  if (status === "approved") return "crm-badge crm-badge--active";
  if (status === "rejected" || status === "cancelled") return "crm-badge crm-badge--rejected";
  if (status === "submitted") return "crm-badge crm-badge--pending";
  if (status === "draft") return "crm-badge crm-badge--draft";
  return "crm-badge";
}

export const BILLING_CATEGORIES = [
  "Billable",
  "Non-billable",
  "Overtime",
  "Double time",
  "Training",
  "Admin",
  "Leave",
];

export const EXPENSE_TYPES = [
  "Expense",
  "Out of Pocket – Reimbursable",
  "Per Diem – Travel Allowance",
  "Corporate Credit Card",
  "Mileage",
];

export function toIso(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function todayIso(timezone?: string): string {
  if (!timezone) return toIso(new Date());
  try {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: timezone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date());
  } catch {
    return toIso(new Date());
  }
}

export function mondayOf(iso: string): string {
  const [year, month, day] = iso.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  const offset = (date.getDay() + 6) % 7;
  date.setDate(date.getDate() - offset);
  return toIso(date);
}

export function weekDays(weekOf: string): { iso: string; label: string }[] {
  const start = mondayOf(weekOf);
  const [year, month, day] = start.split("-").map(Number);
  const labels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  return labels.map((label, index) => {
    const date = new Date(year, month - 1, day + index);
    return { iso: toIso(date), label: `${label} ${date.getDate()}` };
  });
}

export function shiftWeek(weekOf: string, delta: number): string {
  const [year, month, day] = mondayOf(weekOf).split("-").map(Number);
  const date = new Date(year, month - 1, day + delta * 7);
  return toIso(date);
}

export function formatElapsed(seconds: number): string {
  const safe = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const rest = safe % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(rest).padStart(2, "0")}`;
}

export function asNumber(value: string | number | null | undefined): number {
  return Number(value ?? 0) || 0;
}
